<template>
    <div class="c-thanks-page">
            <img class="c-thanks-page__logo" src="../../public/img/png/logo-white.png" alt="">
        <div class="c-thanks-page__content">
            <h2 class="c-thanks-page__headline">¡Muchas gracias!</h2>
            <p class="c-thanks-page__paragraph">Tu mensaje fue enviado, <br>te responderemos a la brevedad.</p>
        </div>
        <div class="c-thanks-page__btn">
            <a class="c-thanks-page__btn-link" @click="regresar">Volver al inicio</a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Gracias',
  methods: {
    regresar () {
      this.$store.commit('showGraciasView', false)
      this.$router.push('/')
    }
  },
  mounted () {
    // gtag('event', 'conversion', {'send_to': 'AW-11025123416/cpBaCMXg3oMYENiQmIkp'})
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/base/_variables.scss";
.c-thanks-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100vh;
    background: rgb(93,140,183);
background: linear-gradient(42deg, rgba(93,140,183,1) 0%, rgba(133,201,246,1) 12.5%, rgba(140,152,226,1) 25%, rgba(151,74,192,1) 40%, rgba(153,65,189,1) 55%, rgba(135,57,172,1) 70%, rgba(90,36,131,1) 85%, rgba(53,19,96,1) 100%);
    padding: 80px 0;
    font-family: Rubik, Helvetica, sans-serif;
    @media screen and (min-width: 1600px) {
        padding: 100px 0;
    }
    &__logo {
        width: 220px;
        fill: #000;
        transition: all .3s ease-in;
        will-change: transform;
        &:hover {
            transition: all .3s ease-out;
            @media screen and (min-width: 769px) {
                transform: scale(1.01) translateY(3px);
            }
        }
        @media screen and (min-width: 1600px) {
            width: 240px;
        }
    }
    &__headline {
        margin: 0px 0px 40px 0px;
        font-size: 66px;
        font-weight: 700;
        color: #fff;
        text-align: center;
        line-height: 58px;
        @media screen and (min-width: 769px) {
            margin: -15px 0px 30px 0px;
            line-height: normal;
        }
        @media screen and (min-width: 1600px) {
            font-size: 100px;
        }
    }
    &__paragraph {
        font-size: 18px;
        color: #fff;
        text-align: center;
        @media screen and (min-width: 769px) {
            font-size: 28px;
            br {
                display: none;
            }
        }
        @media screen and (min-width: 1600px) {
            font-size: 42px;
        }
    }
    &__btn {
        padding: 22px 25px 20px 25px;
        background-color: #fff;
        font-size: 14px;
        text-transform: uppercase;
        text-decoration: none;
        letter-spacing: 3px;
        // box-shadow: -3px 3px #d4dce3;
        border-radius: 4px;
        transition: all .3s ease-in;
        &:hover {
            cursor: pointer;
            -webkit-box-shadow: -5px 5px #d4dce3;
            box-shadow: -5px 5px #d4dce3;
            transition: all .3s ease-out;
        }
        &-link {
            color: #21221E;
        }
        @media screen and (min-width: 1600px) {
            font-size: 16px;
        }
    }
}
</style>
